export  const dbEs = [
    {
      id: 1,
      nameProject: "Amazona e-commerce",
      description: "Espania ipsum dolor sit amet consectetur adipisicing elit. Autem, impedit, voluptate illum recusandae aut iste quisquam sed consectetur enim animi sint nisi voluptates eius porro. Sapiente unde aliquam inventore ut temporibus, similique enim quae error qui atque maxime voluptate magnam? Facilis ab placeat optio, id sed, tenetur repellendus sequi vero voluptatibus maiores beatae dolorem ea laboriosam fuga mollitia! Reiciendis, omnis!",
      tecnologies: "Mongo, Express, React, Nodejs, SockeIo, Auth0, Redux",
      gitHub: "https://github.com/cristian-daniel88/amazonaMVC",
      linkFront1: "https://amazing-ecomerce.herokuapp.com",
      linkFront2: "",
      linkApi1: "https://ecomerceamazona.herokuapp.com",
      linkApi2: "",
      videoLink:""
    },
  
    {
      id : 2,
      nameProject: "PedimonYa I",
      description: "pedimon ipsum dolor sit amet consectetur adipisicing elit. Autem, impedit, voluptate illum recusandae aut iste quisquam sed consectetur enim animi sint nisi voluptates eius porro. Sapiente unde aliquam inventore ut temporibus, similique enim quae error qui atque maxime voluptate magnam? Facilis ab placeat optio, id sed, tenetur repellendus sequi vero voluptatibus maiores beatae dolorem ea laboriosam fuga mollitia! Reiciendis, omnis!",
      tecnologies: "React, Firebase, Redux",
      gitHub: "https://github.com/cristian-daniel88/PokeRedux",
      linkFront1: "https://poke-redux.vercel.app",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink: "",
    },
  
    {
      id : 3,
      nameProject: "HomeBanking",
      description: "hoebanking ipsum dolor sit amet consectetur adipisicing elit. Autem, impedit, voluptate illum recusandae aut iste quisquam sed consectetur enim animi sint nisi voluptates eius porro. Sapiente unde aliquam inventore ut temporibus, similique enim quae error qui atque maxime voluptate magnam? Facilis ab placeat optio, id sed, tenetur repellendus sequi vero voluptatibus maiores beatae dolorem ea laboriosam fuga mollitia! Reiciendis, omnis!",
      tecnologies: "HTML, CSS, JavaScript, localstorage",
      gitHub: "https://github.com/cristian-daniel88/homeBankingCristianDHerrera",
      linkFront1: "https://home-banking-cristian-dh-errera.vercel.app",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink:""
    },
  
    {
      id : 4,
      nameProject: "PedimonYa II",
      description: "pedimonII ipsum dolor sit amet consectetur adipisicing elit. Autem, impedit, voluptate illum recusandae aut iste quisquam sed consectetur enim animi sint nisi voluptates eius porro. Sapiente unde aliquam inventore ut temporibus, similique enim quae error qui atque maxime voluptate magnam? Facilis ab placeat optio, id sed, tenetur repellendus sequi vero voluptatibus maiores beatae dolorem ea laboriosam fuga mollitia! Reiciendis, omnis!",
      tecnologies: "HTML, CSS, JavaScript, Bootstrap",
      gitHub: "https://github.com/cristian-daniel88/pedimonYa",
      linkFront1:"https://pedimon-ya.vercel.app",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink:""
    }
  
  
  ]

  export  const dbEn = [
    {
      id: 1,
      nameProject: "CHECK VAN FLEET",
      description: "The application is basically a system for records reports, built using React, Express, and MongoDB. This project is particularly interesting because you don’t need to pay to send emails, and there is no limit. It also supports automatic PDF report generation. The backend server was deployed on Railway, using a free or very low-cost plan. Since the application has very low egress usage, there is effectively no maintenance cost, practically, you have a fully functional software hosted without any payment. In terms of security, the application uses token-based authentication, and all passwords are hashed and securely stored in MongoDB. No third-party authentication providers are required.",
      tecnologies: "Mongo, Express, React, Nodejs, Google Api, Redux",
      gitHub: "",
      linkFront1: "https://check-van.vercel.app",
      linkFront2: "",
      linkApi1: "admin@cristianherrera.com",
      linkApi2: "12345678",
      videoLink:""
    },

      {
      id : 2,
      nameProject: "CRISTIAN HERRERA GUITAR",
      description: `My Business  2020 - Today
                    I am a professional musician. I had to create business solutions for myself, 
                    such as deploying my own website to promote my services on Google. 
                    On this website, there is a contact form for sending emails, a subscription form, testimonials, 
                    and a media player with my music.
                    I also developed software to generate PDF invoices,
                    as well as other software to record my income and expenses,
                    which I send to my accountant. It is very interesting because I started with a static website,
                    and it has now grown into a large software system that continues to evolve over time.

                    `,
      tecnologies: "PHP, JavaScript, CSS, SQL, MariaDB",
      gitHub: "",
      linkFront1:"https://cristianherreraguitar.co.uk",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink:""
    },
  
    {
      id : 3,
      nameProject: "GAZETTEER",
      description: `Is a map application where you can choose a country and view information such 
                    as its currency converted to US dollars, 
                    news, population, flag, Wikipedia summary, and weather.
                    The main idea of this project is to use GPS data; by using longitude and latitude 
                    as query parameters, the application consumes multiple APIs.
                    If you enter this project, please enable location services.`,
      tecnologies: "PHP, JavaScript, CSS",
      gitHub: "",
      linkFront1: "https://cristianherrera.co.uk/project1",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink: "",
    },
  

  
    {
      id : 4,
      nameProject: "DIRECTORY APP",
      description: `is a directory application where you can create, update, and delete employees, 
                    departments, and cities/countries, as well as assign employees to specific departments or locations.
                    The application also includes a search feature with filters.
                    The main idea of this project is to build a CRUD system using MariaDB and to 
                    create relationships between tables.
                    `,
      tecnologies: "PHP, JavaScript, CSS, SQL, MariaDB",
      gitHub: "",
      linkFront1:"https://cristianherrera.co.uk/project2",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink:""
    },
     


        {
      id : 5,
      nameProject: "HOME BANKING",
      description: `This system allows users to record income and expenses, 
                    create and receive payments, with all data stored in the browser’s 
                    local storage. It is an option if you don’t want to use a database and prefer to store data locally.`,
      tecnologies: "HTML, CSS, JavaScript, localstorage",
      gitHub: "",
      linkFront1: "https://home-banking-cristian-dh-errera.vercel.app",
      linkFront2: "",
      linkApi1: "",
      linkApi2: "",
      videoLink:""
    },
  
  
  ]